@if (url) {
    <div class="form-video-container">
        <div class="form-video-viewer">
            <cerrix-video-player [url]="url"></cerrix-video-player>
        </div>
    </div>
}
